const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the manager reports component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerUsers', ['Application', 'Authorization', 'Managers', 'Users', '$translate', 'escapeHtml', function (Application, Authorization, Managers, Users, $translate, escapeHtml) {
  return {
    restrict: 'E',
    scope: {
      tab: '=',
      manager: '=',
      managerConfiguration: '=?',
      firstSearch: '=',
      singleUser: '=',
      forceRefresh: '='
    },
    replace: true,
    template: require('../../../templates/directives/manager/manager-users.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.loading = true;
      self.user = Authorization.getAuthToken().user;
      self.features = Application.features.flags();
      if ($scope.managerConfiguration && $scope.managerConfiguration.hide_non_managing_groups) {
        self.hideNonManagingGroups = true;
      }

      self.information = {
        groups: {},
        searching: false,
        results: [],
        page: 1,
        per_page: 10,
        managerQuery: true,
        getStandardQuery: function () {
          return {
            subresource: '',
            page: 1,
            per_page: self.information.per_page,
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_grades-populate': 'name',
            'linked_org_levels-populate': 'name',
            'groups-populate': 'name',
            manager_query: true,
            queries: []
          };
        },
        query: {},
        nextPage: function () {
          if (this.results.length < this.per_page) {
            return;
          }
          this.page++;
          this.get();
        },
        previousPage: function () {
          if (this.page <= 1) {
            return;
          }
          this.page--;
          this.get();
        },
        get: function(opts) {
          self.information.reminders = {};
          self.information.searching = false;

          self.information.query.page = self.information.page;

          if (opts) {
            self.information.query.queries = [opts];
          }

          var subresource = {};
          if ($scope.manager.email !== self.user.email) {
            self.information.query.manager_email = $scope.manager.email
          }

          if (opts && opts.suspended) {
            self.information.query.suspended = opts.suspended;
          }

          Managers.users({subresource: $scope.manager._id}, self.information.query).$promise.then(function (results) {
            if (self.features.groups) {
              var allowedGroups = null;
              if (self.hideNonManagingGroups) {
                allowedGroups = {};

                var groupList = self.user && self.user.managing_groups || [];
                groupList.forEach(function(group) {
                  allowedGroups[group] = true;
                });
              }

              results.forEach(function(item) {
                if (!item || !item.user) {
                  return;
                }

                var user = item.user;
                var groupNames = '';

                if (user.groups && user.groups.length) {
                  user.groups.forEach(function(group) {
                    if (!group.name) {
                      return;
                    }
                    if (!group._id || (allowedGroups && !allowedGroups[group._id])) {
                      return;
                    }
                    if (groupNames) {
                      groupNames += ' | ';
                    }
                    groupNames += group.name;
                  });
                }

                user.groupNames = groupNames;
              });
            }

            self.information.results = results;

          }).catch(function(error) {
            console.log('error in findFromQuery: ', error)
          });

        }
      };

      self.suspensionManagement = {
        selectedUserId: '',
        selectedName: '',
        showSuspendBox: false,
        showReinstateBox: false,
        suspendRequest: function(userId, userFullName) {
          self.suspensionManagement.selectedUserId = userId;
          self.suspensionManagement.selectedName = userFullName;
          self.suspensionManagement.showSuspendBox = true;
        },
        suspend: function(userId) {
          Users.suspend({}, {users: [userId]}).$promise.then(data => {
            Application.messaging.addMessage({type: 'success', duration: 5, text: escapeHtml(self.suspensionManagement.selectedName) + self.translations['userManager.selected_user_suspended']});
            self.suspensionManagement.resetActions();
            self.information.get();
          })
          .catch(err => {
            console.error('Error suspending user: ', err);
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['userManager.selected_user_failed_suspend'] + escapeHtml(self.suspensionManagement.selectedName)});
            self.suspensionManagement.resetActions();
          })
        },
        reinstateRequest: function(userId, userFullName) {
          self.suspensionManagement.selectedUserId = userId;
          self.suspensionManagement.selectedName = userFullName;
          self.suspensionManagement.showReinstateBox = true;
        },
        reinstate: function(userId) {
          Users.unsuspend({}, {users: [userId]}).$promise.then(data => {
            Application.messaging.addMessage({type: 'success', duration: 5, text: escapeHtml(self.suspensionManagement.selectedName) + self.translations['userManager.selected_user_reinstated']});
            self.suspensionManagement.resetActions();
            self.information.get();
          })
          .catch(err => {
            console.error('Error reinstating user: ', err);
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['userManager.selected_user_failed_reinstate'] + escapeHtml(self.suspensionManagement.selectedName)});
            self.suspensionManagement.resetActions();
          })        
        },
        resetActions: function() {
          self.suspensionManagement.selectedUserId = '';
          self.suspensionManagement.selectedName = '';
          self.suspensionManagement.showSuspendBox = false;
          self.suspensionManagement.showReinstateBox = false;
        }
      }

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function() {
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(id) {
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === id) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = id;
            }
          } else {
            self.editMenu.activeId = id;
            self.editMenu.visible = true;
          }
        }
      }

      self.search = {
        restrictions: {},
        get: function(opts) {
          self.information.page = 1;
          self.information.query = self.information.getStandardQuery()
          self.information.get(opts);
        }
      };
      self.selectReport = function(id) {
        $scope.singleUser = id;
        $scope.tab = 'user';
      };
      var reset = function() {
        self.information.page = 1;
        self.information.query = self.information.getStandardQuery()
        self.information.get();
      };
      $scope.$watch('manager', function(newVal, oldVal) {
        if ($scope.manager.email !== self.user.email) {
          delete self.search.restrictions.manager_email;
        }
        if ($scope.manager.email !== self.user.email) {
          self.search.restrictions['manager_email'] = $scope.manager.email;
        }
        if (oldVal.email && newVal.email && newVal.email !== oldVal.email) {
          reset();
        }
        self.loading = false;
      }, true);

      var initial = $scope.$watch('firstSearch', function(newVal, oldVal) {
        if (newVal) {
          reset();
          initial();
        }
      });
      $scope.$watch('forceRefresh', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          reset();
          $scope.forceRefresh = false;
        }
      });

      $translate([
        'userManager.selected_user_suspended',
        'userManager.selected_user_failed_suspend',
        'userManager.selected_user_reinstated',
        'userManager.selected_user_failed_reinstate'
        ]).then(function(translations) {
          self.translations = translations;
        })

    }],
    controllerAs: 'reports'
  };
}]);
